module.exports = __webpack_public_path__ + "img/f2-1.c46c651f.jpg";